import React from 'react';
import closeIcon from '../images/close-line.svg';

const TextInput = ({
  type,
  labelName,
  id,
  onChangeFunction,
  value,
  icon,
  required,
  clear,
  inputmode,
}) => {
  const clearInput = () => {
    onChangeFunction({ target: { value: '' } });
  };

  const handleKeyDown = (e) => {
    if (clear && e.key === 'Escape') {
      clearInput();
    }
  };

  return (
    <div className="form-floating">
      <input
        type={type}
        className="form-control"
        id={id}
        placeholder={labelName}
        value={value}
        onChange={onChangeFunction}
        onKeyDown={handleKeyDown}
        required={required}
        min={0}
        inputMode={inputmode}
      />
      <label htmlFor={id} className="form-label">
        {icon && <img src={icon} height={18} width={18} alt="input icon" />}
        {labelName}
      </label>
      {clear && value && (
        <button
          type="button"
          className="btn-clear-input"
          onClick={clearInput}
          aria-label="Clear input"
        >
          <img src={closeIcon} height={24} width={24} />
        </button>
      )}
    </div>
  );
};

export default TextInput;
